exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-simple-suggest {\n  color: black;\n}\n[dir] .vue-simple-suggest.designed .suggestions {\n  background-color: #fff;\n}\n", ""]);

// exports
